import React from "react";
import { useStateValue } from "../StateProvider";
import "./CheckoutProduct.css";

function CheckoutProduct({ id, image, price, rating, title }) {
  const [{cart},dispatch]= useStateValue();
  const removeHandler=()=>{
    dispatch({
      type:"Remove_From_Cart",
      id:id
    })
  }
  return (
    <div className="checkoutProduct">
      <img className="checkoutProduct_image" src={image} alt="" />
      <div className="checkoutProduct_info">
        <p className="checkoutProduct_title">{title}</p>
        <p className="checkoutProduct_price">
          <small>₹</small>
          <strong>{price}</strong>
        </p>
        <div className="CheckoutProduct_rating">
          {Array(rating)
            .fill()
            .map((_) => (
              <p>⭐ </p>
            ))}
        </div>
        <button onClick={removeHandler}>Remove Item</button>
      </div>
    </div>
  );
}

export default CheckoutProduct;
